import lightMobilecall from '@kugou/light-mobilecall'
import md5 from "blueimp-md5"
import kgStatObj from "@kugou/stat";
const { kgStatPush, notifyToStartReporting } = kgStatObj;

export default {
  getIndexConfig () {
    //http://doc.kugou.net/showdoc-master/web/#/5?page_id=4086
    return {
      typeid: 110436,
      state: 1,
      fanxid: window.$userInfo.userid,
      ver: window.$userInfo.clientver || 1000,
      useragent: navigator.userAgent,
      os: lightMobilecall.isIOS ? 1000 : 1005,
      timestamp: +new Date(),
      mid: window.$userInfo.mid || md5(new Date()),
      // 业务字段
      para: /http/.test(window.location.protocol) ? 0 : 1, // 是否离线包 1，是 0 否
    }
  },
  getTimeLength (endTime) {
    if (window.performance && window.performance.timing && typeof window.performance.timing.navigationStart === 'number') return endTime - window.performance.timing.navigationStart
    if (window.performance && typeof window.performance.timeOrigin === 'number') return endTime - parseInt(window.performance.timeOrigin)
    return 0
  },
  /**
   * @description 首页首屏加载时延上报
   * @param { Number } endTime 上报时间戳
   * @param { String } te 错误类型
   * @param { Number } fs 错误状态码
   * */
  indexLoadTime ({ endTime, te, fs }) {
    if (this._indexLoadTime) return
    this._indexLoadTime = true
    const data = this.getIndexConfig()
    data.timelength = this.getTimeLength(endTime)
    console.log('首屏时延', data.timelength)
    if (te) {
      data.state = 0
      data.te = te
      data.position = 0
      data.fs = fs
    }
    kgStatPush(data, 1)
  },
  errStat({te, position, fs, hash}){
    const data = this.getIndexConfig()
    console.log('错误上报', {te, position, fs, hash})
    if (te) {
      data.state = 0
      data.te = te
      data.position = position
      data.fs = fs
      data.hash = hash
    }
    kgStatPush(data, 1)
  },
  sucStat(){
    const data = this.getIndexConfig()
    data.state = 1
    kgStatPush(data, 1)
  }
}
